import { request } from "../../utils/config"

export const TRANSFER_PURCHASE = async (data) => {
  const response = await request({
    url: `Purchases/TransferWarehouse`,
    method: "PUT",
    params: data,
    // data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

// 1-bosqich TZ: bitta hujjatda ko'p tovarli perevod
export const CREATE_TRANSFER_DOC = async (data: {
  toWarehouseId: number
  note?: string
  items: { purchaseId: number; transferCount: number; note?: string; transferPriceUSD?: number }[]   // tog'a #2888
  hideQty?: boolean   // tog'a #3248: «скрытый приём»
  priceKind?: "dona" | "optom"   // tog'a #4741: perevod narxi turi (hujjatda saqlanadi)
}) => {
  const response = await request({
    url: `TransferLogs/CreateDoc`,
    method: "POST",
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const APPROVE_TRANSFER = async (id: number) => {
  const response = await request({
    url: `TransferLogs/Approve/${id}`,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const DELIVER_TRANSFER = async (id: number) => {
  const response = await request({
    url: `TransferLogs/Deliver/${id}`,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

// 2-bosqich TZ: bekor qilish — zaxira manba omborga qaytadi; tog'a #2455: sabab jurnalga yoziladi
export const CANCEL_TRANSFER = async (id: number, reason?: string) => {
  const response = await request({
    url: `TransferLogs/Cancel/${id}`,
    method: "PUT",
    params: reason ? { reason } : undefined,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

// tog'a #2455 (2026-09-24): qabul qiluvchi sklad rad etadi (sabab majburiy) — tovar jo'natuvchiga qaytadi
export const REJECT_TRANSFER = async (id: number, reason: string) => {
  const response = await request({ url: `TransferLogs/Reject/${id}`, method: "PUT", params: { reason } })
  return response.data
}

// tog'a #2455: perevod tarixi (hujjat, tovarlar, jurnal)
// tog'a #2888 (2026-09-26): aniq perevod narxi — qabul qilinguncha jo'natuvchi sklad o'zgartiradi
export const SET_TRANSFER_PRICE = async (id: number, priceUSD: number) => {
  const response = await request({ url: `TransferLogs/Price/${id}`, method: "PUT", params: { priceUSD } })
  return response.data
}

export const GET_TRANSFER_HISTORY = async (id: number) => {
  const response = await request({ url: `TransferLogs/History/${id}`, method: "GET" })
  return response.data
}

// 2-bosqich TZ: tafovut bilan qabul (fakt miqdor)
// tog'a #3248 (2026-10-03): «скрытый приём» belgisini yoqish/o'chirish (jo'natuvchi sklad, qabulgacha)
export const SET_TRANSFER_HIDE_QTY = async (docId: number, on: boolean) => {
  const response = await request({ url: `TransferLogs/HideQty/${docId}`, method: "PUT", params: { on } })
  return response.data
}

export const ACCEPT_TRANSFER_WITH_COUNT = async (id: number, actualCount: number) => {
  const response = await request({
    url: `TransferLogs/AcceptWithCount/${id}`,
    method: "PUT",
    params: { actualCount },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

// tog'a #3177 (2026-10-02): «Ожидание»dagi perevodni o'zgartirish — son, qator qo'shish/olib tashlash, qabul ombori, izoh
export const EDIT_TRANSFER_DOC = async (docId: number, data: {
  toWarehouseId?: number
  note?: string
  reason?: string
  items: { id?: number; purchaseId: number; transferCount: number; note?: string; transferPriceUSD?: number }[]
}) => {
  const response = await request({ url: `TransferLogs/Edit/${docId}`, method: "PUT", data })
  return response.data
}
